import React, { useState, useEffect } from 'react';
import { Button, Dropdown, Image } from 'semantic-ui-react'
import { lineItemOptions } from './reasonList';
import Images from '../config/images'
import PopUpIcon from '../formComponents/PopUpIcon'
import _ from 'lodash'

const PscLineItemReason = (props) => {
    const merchandiseId = props.merchandiseId
    const [state, setState] = useState({
        pscLineReason: {
            [props.merchandiseId]: false 
        }
    });
    
    const [selectedReason, setReason] = useState({
        selectedLineReason: props.selectedOptions
    });
    
    // const [onChangeCalled, setOnChangeCalled] = useState({
    //     onChangeCalled: false
    // });

    const [lineError, setLineError] = useState(false);
    // useEffect(() => {
    //     if(onChangeCalled.onChangeCalled && selectedReason.selectedLineReason && selectedReason.selectedLineReason.length === 0){
    //         onBlurReason();
    //         setOnChangeCalled({"onChangeCalled": false})
    //     }
    // }, [selectedReason]);
      
    let pscState = props.pscState;
    if(typeof pscState!== 'string'){
        pscState = _.get(props.pscState,"value.state")
    }
    const isPscDisableForm = !((pscState === 'STATE_PSC_IN_PROCESS' || pscState === 'STATE_PSC_READY'));
    const pscDisabled = isPscDisableForm ? 'disableForm': '';
    const isTheOwningBroker = !props?.kxUserBasicInfo?.userGuid ||  !props?.currentJobData?.brokerGuid || props?.kxUserBasicInfo?.userGuid  == props?.currentJobData?.brokerGuid;
    const onChangeReason = (event, data) => {
            let selectedReason = data.value;
            setLineError(false)
            if(selectedReason.length < 6){
                if(selectedReason.length === 0){
                    //setOnChangeCalled({"onChangeCalled": true})
                    props.enableDisableFrom(false)
                }else{
                  props.enableDisableFrom(true)
                }
                setReason({"selectedLineReason": selectedReason});
            }else{
                setLineError(true)
            }
      }
    
    const onBlurReason = (e) => {
        if(!isTheOwningBroker)return;
        let lineReason = selectedReason.selectedLineReason;
        let updatedReason = [];
        lineReason && lineReason.map((item)=>{
          let desc = lineItemOptions.filter((_item)=> {
            return _item.key == item
          });
          
          updatedReason.push({
            "code": item, 
            "desc": desc[0]['description']
        })
      })
      props.saveLineReason(props.merchandiseId, updatedReason, props.lineItemIndex);
    }
    const handlePscState = (e) => {
        if(!isTheOwningBroker)return;
        setState({
            "pscLineReason": {
                [merchandiseId]: true 
            }
        })
        props.enableDisableFrom(true)
    }
    
    const cancelPsc = (e) => {
        let type = e.target.dataset.type;
        setState({
            "pscLineReason": {
                [merchandiseId]: false 
            }
        })
        props.enableDisableFrom(false)
    }
    let noPSCReasons = !state.pscLineReason[merchandiseId] && !selectedReason.selectedLineReason.length;
    return (
        <div className={`psc-rect-box ${pscDisabled}`}  style={isTheOwningBroker?{}:{cursor:'not-allowed'}}>
            {
                noPSCReasons && 
                    <div data-type="pscLineReason" onClick={handlePscState} className='add-a-psc-txt'><Image src={Images.add_doc} /> Add a PSC line item reason for this section.</div> 
            }
                
                <div style={noPSCReasons?{display:'none'}:{}}><div className='psc-dropdown-heading'>Add one or more reason for Post Summary Correction for this section.<PopUpIcon icon='info circle' popupText={'You can select only 5 reasons per line item'} /></div>
                <div>
                <Dropdown 
                disabled={!isTheOwningBroker}
                lazyLoad={true}
                id={`dom-lineitem-reason-${merchandiseId}`} 
                data='dom-line-reason'
                className='dom-line-reason' 
                onChange={onChangeReason}
                onBlur={onBlurReason}
                placeholder='PSC Line Item Reasons' 
                fluid multiple selection 
                options={lineItemOptions} 
                value={selectedReason.selectedLineReason}
                style={{"width": "100%", "display":"inline-block"}}
                /></div>
                {
                    lineError && <div className='error'>You can select only 5 Line Reasons per line item.</div>
                }
                </div>
            
        </div>);

}

export default PscLineItemReason;